import { DayOfWeek, TimeSlot } from '@/models/Schedule';
import { parse, isAfter, areIntervalsOverlapping } from 'date-fns';

export const useTimeSlotValidation = (existingTimeSlots: TimeSlot[]) => {
  // Helper function to parse time string to Date object
  const parseTime = (timeString: string): Date => {
    return parse(timeString, 'HH:mm', new Date(2000, 0, 1));
  };

  const validateTimeRange = (startTime: string, endTime: string): boolean => {
    const start = parseTime(cleanupTime(startTime));
    const end = parseTime(cleanupTime(endTime));

    return isAfter(end, start);
  };

  const checkForOverlaps = (
    day: DayOfWeek,
    startTime: string,
    endTime: string,
    workoutTypeId: string
  ): boolean => {
    const daySlots = existingTimeSlots.filter(
      (slot) =>
        slot.day === day &&
        slot.isActive &&
        slot.workoutTypeId === workoutTypeId // Only check overlaps for the same workout type
    );

    const newStart = parseTime(cleanupTime(startTime));
    const newEnd = parseTime(cleanupTime(endTime));

    for (const existingSlot of daySlots) {
      const existingStart = parseTime(cleanupTime(existingSlot.startTime));
      const existingEnd = parseTime(cleanupTime(existingSlot.endTime));

      // Check for overlap using date-fns areIntervalsOverlapping
      if (
        areIntervalsOverlapping(
          { start: newStart, end: newEnd },
          { start: existingStart, end: existingEnd }
        )
      ) {
        return true;
      }
    }
    return false;
  };

  return {
    validateTimeRange,
    checkForOverlaps,
  };
};

function cleanupTime(time: string): string {
  // Ensure time is in HH:mm format
  const parts = time.split(':');
  if (parts.length < 2) return time; // Return as is if format is unexpected
  const hours = parts[0].padStart(2, '0');
  const minutes = parts[1].padStart(2, '0');
  return `${hours}:${minutes}`;
}
